import React from 'react';

function BannerLab() {
    const handleClick = () => {
        window.open('https://dental-lab-system.web.app/find-lab', '_blank');
    };

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f1f5f9',
            padding: 20,
        }}>
            {/* 200 x 260 배너 */}
            <div onClick={handleClick} style={{
                width: 200,
                height: 260,
                background: 'linear-gradient(160deg, #0f172a 0%, #1e293b 50%, #4f46e5 100%)',
                borderRadius: 16,
                cursor: 'pointer',
                position: 'relative',
                overflow: 'hidden',
                boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
                fontFamily: "'Noto Sans KR', sans-serif",
                color: '#fff',
                display: 'flex',
                flexDirection: 'column',
                padding: 18,
                boxSizing: 'border-box',
                transition: 'transform 0.2s',
            }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; }}
            >
                {/* 배경 장식 */}
                <div style={{
                    position: 'absolute',
                    top: -30, right: -30,
                    width: 100, height: 100,
                    borderRadius: '50%',
                    background: 'radial-gradient(circle, rgba(129,140,248,0.3) 0%, transparent 70%)',
                }} />
                <div style={{
                    position: 'absolute',
                    bottom: -40, left: -40,
                    width: 120, height: 120,
                    borderRadius: '50%',
                    background: 'radial-gradient(circle, rgba(99,102,241,0.25) 0%, transparent 70%)',
                }} />

                {/* 상단 로고 */}
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    marginBottom: 4,
                    position: 'relative',
                    zIndex: 1,
                }}>
                    <div style={{
                        width: 22, height: 22, borderRadius: 5,
                        background: 'linear-gradient(135deg, #6366f1, #818cf8)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        fontSize: 9, fontWeight: 900,
                    }}>DC</div>
                    <span style={{ fontSize: 10, fontWeight: 600, color: 'rgba(255,255,255,0.7)' }}>DentalCluster</span>
                </div>

                {/* 타이틀 */}
                <div style={{
                    fontSize: 17,
                    fontWeight: 900,
                    lineHeight: 1.25,
                    margin: '8px 0 6px',
                    position: 'relative',
                    zIndex: 1,
                    letterSpacing: '-0.5px',
                }}>
                    기공소 영업,<br />
                    저희가 <span style={{ color: '#818cf8' }}>대신</span>
                </div>

                {/* 핵심 메시지 */}
                <div style={{
                    fontSize: 10,
                    color: 'rgba(255,255,255,0.7)',
                    lineHeight: 1.5,
                    marginBottom: 8,
                    position: 'relative',
                    zIndex: 1,
                }}>
                    덴탈아리랑 · 인스타그램<br />
                    카페 바이럴까지
                </div>

                {/* 가격 강조 */}
                <div style={{
                    background: 'rgba(255,255,255,0.1)',
                    border: '1px solid rgba(255,255,255,0.15)',
                    borderRadius: 8,
                    padding: '6px 10px',
                    marginBottom: 8,
                    position: 'relative',
                    zIndex: 1,
                    backdropFilter: 'blur(10px)',
                }}>
                    <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.6)', marginBottom: 1 }}>월 구독료</div>
                    <div style={{ fontSize: 20, fontWeight: 900, color: '#fff', letterSpacing: '-0.5px' }}>
                        10만원<span style={{ fontSize: 11, fontWeight: 500, color: 'rgba(255,255,255,0.5)', marginLeft: 2 }}>/월</span>
                    </div>
                </div>

                {/* CTA 버튼 */}
                <div style={{
                    marginTop: 'auto',
                    background: '#fff',
                    color: '#4f46e5',
                    borderRadius: 8,
                    padding: '10px 12px',
                    textAlign: 'center',
                    fontSize: 12,
                    fontWeight: 800,
                    position: 'relative',
                    zIndex: 1,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                }}>
                    지금 등록하기 →
                </div>

                {/* 도메인 */}
                <div style={{
                    textAlign: 'center',
                    fontSize: 9,
                    color: 'rgba(255,255,255,0.5)',
                    marginTop: 6,
                    position: 'relative',
                    zIndex: 1,
                    letterSpacing: '0.3px',
                }}>
                    www.dentalcluster.com
                </div>
            </div>
        </div>
    );
}

export default BannerLab;
